export const moveItemInArray = (itemToMove, newIndex, originalArray) => {
  const arrayWithoutItem = originalArray.filter((item) => item !== itemToMove);
  arrayWithoutItem.splice(newIndex, 0, itemToMove);

  return [...arrayWithoutItem];
};

export const changeSingleValue = (idx, newValue, originalValues) => {
  const values = [...originalValues];
  const item = { ...originalValues[idx] };
  const newItem = { ...item, value: newValue };

  values[idx] = newItem;

  return values;
};
